var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationOutlineGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.1,
    height: 29.1,
    viewBox: "0 0 29.1 29.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_001-cpu",
    "data-name": "001-cpu",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12699",
    "data-name": "Path 12699",
    d: "M214.613,210h-4.05a.563.563,0,0,0-.562.563v4.05a.563.563,0,0,0,.563.563h4.05a.563.563,0,0,0,.563-.562v-4.05A.563.563,0,0,0,214.613,210Zm-.562,4.05h-2.925v-2.925h2.925Z",
    transform: "translate(-198.188 -198.188)",
    fill: "#50C150",
    stroke: "#50C150",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12700",
    "data-name": "Path 12700",
    d: "M445.913,54a1.912,1.912,0,1,0,1.913,1.912A1.915,1.915,0,0,0,445.913,54Zm0,2.7a.787.787,0,1,1,.788-.787A.788.788,0,0,1,445.913,56.7Z",
    transform: "translate(-419.025 -50.963)",
    fill: "#50C150",
    stroke: "#50C150",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12701",
    "data-name": "Path 12701",
    d: "M410.48,78.135a.562.562,0,1,0,.165.4A.567.567,0,0,0,410.48,78.135Z",
    transform: "translate(-386.484 -73.584)",
    fill: "#50C150",
    stroke: "#50C150",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12702",
    "data-name": "Path 12702",
    d: "M51.657,14.963a1.913,1.913,0,1,0,0-1.125H48.2V9.45a.563.563,0,0,0-.562-.562h-.9V5.511h3.151a.563.563,0,0,0,0-1.125H46.171a.563.563,0,0,0-.563.563V8.887H43.246V5.426a1.913,1.913,0,1,0-1.125,0V8.887H37.733a.563.563,0,0,0-.562.563v.9H33.794V3.741a1.912,1.912,0,1,0-1.125,0v7.173a.563.563,0,0,0,.563.563h3.939v2.363H33.709a1.912,1.912,0,1,0,0,1.125h3.461V19.35a.563.563,0,0,0,.563.563h.9v3.377H35.482a.562.562,0,0,0,0,1.125H39.2a.563.563,0,0,0,.563-.562V19.913h2.363v3.461a1.912,1.912,0,1,0,1.125,0V19.913h4.387a.563.563,0,0,0,.563-.562v-.9h3.377v6.609a1.912,1.912,0,1,0,1.125,0V17.888a.563.563,0,0,0-.562-.562H48.2V14.963Zm1.828-1.35a.787.787,0,1,1-.788.788A.788.788,0,0,1,53.485,13.613ZM33.233,2.7a.788.788,0,1,1,.787-.788A.788.788,0,0,1,33.233,2.7ZM31.882,15.188a.787.787,0,1,1,.787-.787A.788.788,0,0,1,31.882,15.188ZM41.9,3.6a.788.788,0,1,1,.788.787A.788.788,0,0,1,41.9,3.6Zm1.575,21.6a.788.788,0,1,1-.787-.788A.788.788,0,0,1,43.471,25.2Zm3.6-6.414H38.3V10.012h8.775ZM52.133,26.1a.788.788,0,1,1-.787.788A.788.788,0,0,1,52.133,26.1Z",
    transform: "translate(-28.284)",
    fill: "#50C150",
    stroke: "#50C150",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12703",
    "data-name": "Path 12703",
    d: "M1.913,390a1.913,1.913,0,1,0,1.913,1.913A1.915,1.915,0,0,0,1.913,390Zm0,2.7a.788.788,0,1,1,.788-.787A.788.788,0,0,1,1.913,392.7Z",
    transform: "translate(0 -368.063)",
    fill: "#50C150",
    stroke: "#50C150",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12704",
    "data-name": "Path 12704",
    d: "M83.46,414.195a.562.562,0,1,0,.165.4A.567.567,0,0,0,83.46,414.195Z",
    transform: "translate(-77.859 -390.741)",
    fill: "#50C150",
    stroke: "#50C150",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationOutlineGreen);
export default __webpack_public_path__ + "static/media/integration_outline_green.6b762fabc1bf363988fbd59405a528a8.svg";
export { ForwardRef as ReactComponent };